var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-modal',{attrs:{"value":_vm.value,"width":500},on:{"input":args => _vm.$emit('input', args)}},[_c('referral-form',{attrs:{"referral":_vm.referral,"requesting":_vm.requesting},on:{"submit":args => _vm.$emit('submit', args),"cancel":function($event){return _vm.$emit('input', false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }